'use strict';
angular.module('schoolLinqApp').factory('arItemService', [
	'$http',
	function ($http) {
		var endpoint = '/api/accounts-receivable/items';

		function getARItems() {
			return $http.get(endpoint);
		}

		function searchARItems(itemCode, active, limit) {
			return $http.get(endpoint + '/search', {
				params: { itemCode: itemCode, active: active, limit: limit },
			});
		}

		function getARItem(id) {
			return $http.get(endpoint + '/' + id);
		}

		function addARItem(arItem) {
			return $http.post(endpoint, arItem);
		}

		function updateARItem(arItem) {
			return $http.put(endpoint + '/' + arItem.Id, arItem);
		}

		function deleteARItem(id) {
			return $http.delete(endpoint + '/' + id, id);
		}

		return {
			getARItems: getARItems,
			addARItem: addARItem,
			getARItem: getARItem,
			updateARItem: updateARItem,
			deleteARItem: deleteARItem,
			searchARItems: searchARItems,
		};
	},
]);
